<template>
    <div>
        <el-row class="search-add" :gutter="10">
            <el-col :span="6">
                <el-input placeholder="车辆品牌" v-model="name"></el-input>
            </el-col>
            <el-col :span="16">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
            <el-col :span="2">
                <router-link to="./add">
                    <el-button type="success">新增</el-button>
                </router-link>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="name" label="车辆品牌">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="Edit(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="Delete(scope.$index)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        data() {
            return {
                name:'',
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                }
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    page: this.pagin.pageNum,
                    limit: this.pagin.pageSize,
                }
                if(this.name.trim() !='') {
                    params.name = this.name;
                }
                this.$http.get('/manage/car-brand/list', {params:params}).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            },
            Delete(index) {
                //单删
                if(confirm('确认要删除吗？')) {
                    let ID = this.data[index].id;
                    this.$http.post('/manage/car-brand/delete',[ID]).then(() => {
                        this.data.splice(index, 1);
                    })
                }
            },
            Edit(row) {
                this.$store.state.editInfo = row;
                this.$router.push('./edit/'+row.id);
            }
        },
        components: { Pagination }
    }
</script>